import { GetterTree } from 'vuex';
import { State } from '@/stores/quotes/state';

export class Getters implements GetterTree<State, any> {
    [key: string]: (state: State, getters: any, rootState: any, rootGetters: any) => any;

    public allQuotes = (state: State) => state.allQuotes;
    public allQuotesPage = (state: State) => state.allQuotesPageNumber;
    public allQuotesPageSize = (state: State) => state.allQuotesPageSize;
    public allQuotesTotalPages = (state: State) => state.allQuotesTotalPages;
    public allQuotesTotal = (state: State) => state.allQuotesTotal;
    public allQuotesFilterStatus = (state: State) => state.allQuotesFilterStatus;
    public allQuotesFrom = (state: State) => state.allQuotesFrom;
    public allQuotesTo = (state: State) => state.allQuotesTo;
}
